<template>
  <!-- Cinco destinos permanentes. Diretiva 10: ícone sempre com rótulo — ícone sozinho é
       charada, e a barra é o mapa do app. -->
  <nav class="tabs" aria-label="Navegação principal">
    <router-link
      v-for="r in targets"
      :key="r.name"
      :to="targetOf(r)"
      class="tab"
      @click="onTap(r)"
    >
      <AppIcon :name="r.meta.icon" size="lg" />
      <span>{{ r.meta.label }}</span>
    </router-link>
  </nav>
</template>

<script>
import AppIcon from './ui/AppIcon.vue';

export default {
  name: 'BottomNav',
  components: { AppIcon },
  methods: {
    /**
     * Para onde cada aba leva.
     *
     * Só "Jogar" tem decisão: ela é a tela da partida, e a partida pode ter vindo de
     * qualquer modo. As outras vão para o próprio caminho — a trilha tem aba desde que
     * deixou de ser linha da folha de modos, então o mapa não precisa mais ser destino
     * emprestado de "Jogar".
     */
    targetOf(rota) {
      return rota.name === 'game' ? '/' : rota.path;
    },
    /**
     * Tocar na aba em que já se está não navega, e o app parecia travado — quem fechou a
     * folha de modos não tinha como reabri-la pela barra. O aviso vai por evento de
     * `window` porque a barra não conhece a tela que está montada.
     */
    onTap(rota) {
      if (this.$route.path === this.targetOf(rota)) {
        window.dispatchEvent(new CustomEvent('sentido:tab-repeat'));
      }
    },
  },
  computed: {
    targets() {
      // A ordem é a do roteador, e o rótulo é o que decide se a rota entra na barra.
      return this.$router.getRoutes().filter((r) => r.meta?.label);
    },
  },
};
</script>

<style scoped>
.tabs {
  grid-area: tabs;
  display: grid;
  /* Colunas pelo número de destinos: fixar em cinco deixaria a aba nova fora da barra. */
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  border-top: 1px solid var(--line);
  background: var(--bg);
  padding: 10px 6px calc(10px + env(safe-area-inset-bottom));
}

.tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: var(--touch);
  color: var(--text-3);
  text-decoration: none;
  font: 700 11px/1 var(--f-body);
  transition: color 0.16s;
}

.tab:hover { color: var(--text-2); }

/* A aba corrente é branca e o resto é 55% — a mesma escada de contraste do resto do app. */
.tab.router-link-active { color: var(--text); }
</style>
